import { Anchor, Button, Card, Flex, Grid, Image, Text } from '@mantine/core';
import { IconCopy, IconFileSpreadsheet, IconFileText, IconFileTypePdf, IconFileWord } from '@tabler/icons-react';
import { useLocation } from 'react-router';

export const DocumentAssetIcon = ({ assetType, size = 144 }) => {
  switch (assetType) {
    case 'application/pdf':
      return <IconFileTypePdf size={size} />;
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return <IconFileWord size={size} />;
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return <IconFileSpreadsheet size={size} />;
    case 'text/plain':
      return <IconFileText size={size} />;
    default:
      return <IconFileText size={size} />;
  }
};

const AssetsCards = ({ assets }) => {
  const location = useLocation();

  const assetElements = [];
  for (const asset of assets) {
    const isImageAsset = asset.type.startsWith('image');

    assetElements.push(
      <Grid.Col span={{ base: 12, sm: 3 }} key={asset.id}>
        <Card withBorder h="100%" style={{ display: 'flex', flexDirection: 'column' }}>
          <Card.Section inheritPadding py="sm">
            {isImageAsset ? (
              <Image alt={asset.title} src={asset.thumbUrl} radius="sm" />
            ) : (
              <Flex justify="center">
                <DocumentAssetIcon assetType={asset.type} />
              </Flex>
            )}
          </Card.Section>
          {asset.description && (
            <Card.Section inheritPadding py="sm">
              <Text size="sm" c="dimmed">
                {asset.description}
              </Text>
            </Card.Section>
          )}
          <Card.Section inheritPadding py="sm" mt="auto">
            <Anchor
              href={`#${location.pathname}/${asset.id}`}
              fw={600}
              mb="xs"
              ta="center"
              style={{ display: 'block' }}
            >
              {asset.title}
            </Anchor>
            <Flex gap="xs" justify="flex-end">
              <Button
                variant="light"
                size="compact-xs"
                leftSection={<IconCopy size={14} />}
                onClick={() => {
                  navigator.clipboard.writeText(asset.url);
                }}
              >
                Copy URL
              </Button>
              {isImageAsset && asset.thumbUrl && (
                <Button
                  variant="light"
                  size="compact-xs"
                  leftSection={<IconCopy size={14} />}
                  onClick={() => {
                    navigator.clipboard.writeText(asset.thumbUrl);
                  }}
                >
                  Copy Thumbnail
                </Button>
              )}
            </Flex>
          </Card.Section>
        </Card>
      </Grid.Col>
    );
  }
  return <Grid align="stretch">{assetElements}</Grid>;
};

export default AssetsCards;
